/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_RenameInputs */

const zh_sidebar_rename = /** @type {(inputs: Sidebar_RenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重命名`)
};

const en_sidebar_rename = /** @type {(inputs: Sidebar_RenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rename`)
};

const es_sidebar_rename = /** @type {(inputs: Sidebar_RenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renombrar`)
};

/**
* | output |
* | --- |
* | "Rename" |
*
* @param {Sidebar_RenameInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const sidebar_rename = /** @type {((inputs?: Sidebar_RenameInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_RenameInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_sidebar_rename(inputs)
	if (locale === "en") return en_sidebar_rename(inputs)
	return es_sidebar_rename(inputs)
});